




import Login from "@/components/Login.vue";

export default {
  name: "Entry",
  components: {
    Login
  }
}
